import { __assign, __extends } from "tslib";
import React from "react";
import { PnmacUIButton, PnmacHtmlToNative, PnmacScroller, PnmacNavigation, PnmacMediaQuery } from 'pnmac-universal-components';
import { View, Image, Text } from 'react-native';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import { windowObject } from '../utils.js';
var Interstitial = /** @class */function (_super) {
  __extends(Interstitial, _super);
  function Interstitial(props) {
    var _this = _super.call(this, props) || this;
    _this.addTracker = function (label) {
      var _a, _b, _c;
      var loanId = (((_a = _this.props.location) === null || _a === void 0 ? void 0 : _a.state) || ((_b = _this.props.route) === null || _b === void 0 ? void 0 : _b.params)).loanId;
      var form = new FormData();
      form.append('LoanId', loanId);
      form.append('TrackerSessionId', parseInt(_this.props.layout.trackerSession));
      form.append('Label', label);
      form.append('Url', (_c = windowObject === null || windowObject === void 0 ? void 0 : windowObject.location) === null || _c === void 0 ? void 0 : _c.pathname);
      form.append('Page', 'Interstitial page');
      fetch("".concat(_this.props.layout.pennyHomeUrl, "api/hippo/addEvents"), {
        method: "POST",
        headers: {
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: form
      }).then(function (s) {
        if (s.ok) {}
      });
    };
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  Interstitial.prototype.componentDidMount = function () {
    PnmacScroller(0, 0);
  };
  Interstitial.prototype.render = function () {
    var _this = this;
    var _a, _b;
    var _c = this.props,
      translations = _c.translations,
      layout = _c.layout;
    var _d = ((_a = this.props.location) === null || _a === void 0 ? void 0 : _a.state) || ((_b = this.props.route) === null || _b === void 0 ? void 0 : _b.params),
      headerText = _d.headerText,
      goTo = _d.goTo,
      goBack = _d.goBack,
      bodyWarning = _d.bodyWarning,
      bodyNotes = _d.bodyNotes,
      BtnGoBackText = _d.BtnGoBackText,
      btnGoToText = _d.btnGoToText;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: headerText
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          borderBottomColor: 'black',
          borderBottomSize: 1
        }
      })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 25,
          backgroundColor: "#FFFFB7"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start"
        }
      }, /*#__PURE__*/React.createElement(Image, {
        source: require("../assets/warning.svg"),
        style: {
          width: 35,
          height: 35
        }
      }), /*#__PURE__*/React.createElement(Text, null, bodyWarning)), /*#__PURE__*/React.createElement(View, {
        style: {
          padding: 25
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: bodyNotes
      })))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: matches.small ? "column" : "row",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: __assign(__assign({}, styles.accountSettings.button), {
          marginTop: 50
        }),
        labelStyle: {
          color: "#003087"
        },
        onPress: function () {
          _this.addTracker("Back to Pennymac Button Clicked");
          PnmacNavigation(__assign({
            action: {
              pathname: layout.mobile ? "MarLanding" : "/"
            }
          }, _this.props));
        }
      }, BtnGoBackText)), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: __assign(__assign({}, styles.accountSettings.button), {
          marginTop: 50
        }),
        labelStyle: {
          color: "#003087"
        },
        onPress: function () {
          _this.addTracker("Continue to Pennymac Insurance Services Button Clicked");
          PnmacNavigation(__assign({
            action: goTo,
            wind: true,
            target: "_blank"
          }, _this.props));
        }
      }, btnGoToText))));
    });
  };
  return Interstitial;
}(React.PureComponent);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(Interstitial);